import { FunctionComponent } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentSms, faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { faBoltLightning } from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';
import NodeMenu from './NodeMenu';
import styles from './BaseStepNode.module.scss';

const ActionNode: FunctionComponent<NodeProps> = ({ data, selected }) => {
    const d = data as {
        type: 'sms' | 'email';
        label: string;
        subtitle: string;
        dayOffset?: number;
        onRemove?: () => void;
        onStepClick?: () => void;
    };

    return (
        <>
            <Handle
                type="target"
                position={Position.Top}
                style={{ opacity: 0, pointerEvents: 'none' }}
            />
            <div
                className={clsx(styles.node, { [styles.selected]: selected })}
                onClick={d.onStepClick}
            >
                <div className={clsx(styles.iconCircle, d.type === 'sms' ? styles.sms : styles.email)}>
                    <FontAwesomeIcon icon={d.type === 'sms' ? faCommentSms : faEnvelope} />
                </div>
                <div className={styles.content}>
                    <span className={styles.title}>{d.label}</span>
                    {d.subtitle && <span className={styles.subtitle}>{d.subtitle}</span>}
                </div>
                {d.onRemove && <NodeMenu onDelete={d.onRemove} />}
                {d.dayOffset !== undefined && (
                    <span className={styles.dayBadge}>
                        <FontAwesomeIcon icon={faBoltLightning} />
                        Day {d.dayOffset}
                    </span>
                )}
            </div>
            <Handle
                type="source"
                position={Position.Bottom}
                style={{ opacity: 0, pointerEvents: 'none' }}
            />
        </>
    );
};

export default ActionNode;
